/**
 * Canonical lowercase strings for EHR vendors as returned by
 * `useVimUserMetadata().ehrVendor`. Keep this file flat — it is the single
 * source of truth so vendor checks across the app don't drift.
 */
export const EHR_VENDORS = {
  ATHENA: 'athena',
  PRACTICE_FUSION: 'practice-fusion',
} as const;

export type EhrVendor = (typeof EHR_VENDORS)[keyof typeof EHR_VENDORS];
